import { useEffect, useState } from 'react';
import { uploadActivityService } from '@vivli/shared/infrastructure/service';

/**
 * Reactive view of the shared upload-activity registry (DEV-485): true whenever any file upload is
 * in progress anywhere in the app. Used by the navigation guard to decide whether to warn the user
 * before they browse away.
 */
export const useHasActiveUploads = (): boolean => {
    const [hasActiveUploads, setHasActiveUploads] = useState<boolean>(uploadActivityService.hasActiveUploads());

    useEffect(() => {
        const subscription = uploadActivityService.hasActiveUploads$.subscribe(setHasActiveUploads);
        return () => subscription.unsubscribe();
    }, []);

    return hasActiveUploads;
};
